import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Widget } from '@spins/react-ui-library';
import FavoritesTable from 'components/FavoritesTable';
import { Query } from '@apollo/client/react/components';
import { QueryResult } from '@apollo/client/react/types/types';
import { FetchFavoritesDocument as fetchFavoritesQuery } from 'generated/favorites-graphql';
import { favGroupsClient } from 'apollo';
import { getData, isEmpty } from 'utils/functions';
import {
  clientIdSelector,
  currentBrandSelector,
  isEnterpriseContextSelector
} from 'store/global/selectors';
import { Alert } from 'react-bootstrap';
import LoadingSpinner from 'components/LoadingSpinner';
import { ROUTES } from 'utils/routes';
import ReactGA from 'react-ga';
import DeleteFavoritesModal from './Delete';
import * as actions from 'containers/Groups/actions';

interface Props {
  clientId: string;
  currentBrand: string;
  isEnterpriseContext: boolean;
  onDelete(id: string, name: string): void;
}

const Favorites: React.FC<Props> = ({ clientId, currentBrand, isEnterpriseContext, onDelete }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    ReactGA.pageview(ROUTES.FAVORITES);
  }, [dispatch]);

  const variables = {
    clientID: clientId,
    ...(isEnterpriseContext && { brandName: currentBrand })
  };

  const handleActionClick = (id: string, name: string) => {
    onDelete(id, name);
  };

  return (
    <Row className="mt-3">
      <Col>
        <Widget>
          {{
            header: {
              title: 'Favorites'
            },
            body: {
              content: (
                <Query
                  query={fetchFavoritesQuery}
                  variables={variables}
                  client={favGroupsClient as any}
                >
                  {(result: QueryResult) => {
                    const { loading, error, data } = result;
                    if (loading) return <LoadingSpinner />;
                    if (error) return <Alert variant="danger">{error.message}</Alert>;
                    if (isEmpty(data)) return <Alert variant="warning">No Data Found</Alert>;
                    return (
                      <FavoritesTable
                        favorites={getData(data)}
                        onActionClick={(id, name) => handleActionClick(id, name)}
                      />
                    );
                  }}
                </Query>
              )
            }
          }}
        </Widget>
      </Col>
      <DeleteFavoritesModal />
    </Row>
  );
};

const mapStateToProps = state => ({
  clientId: clientIdSelector(state),
  currentBrand: currentBrandSelector(state),
  isEnterpriseContext: isEnterpriseContextSelector(state)
});

const mapDispatchToProps = dispatch => ({
  onDelete: (id: string, name: string) => {
    dispatch(actions.openDeleteFavModal(id, name));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Favorites);
